import { render, staticRenderFns } from "./contacts-profile-setting.vue?vue&type=template&id=557bc444&"
import script from "./contacts-profile-setting.vue?vue&type=script&lang=js&"
export * from "./contacts-profile-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports